import { ConnectButton } from '@rainbow-me/rainbowkit'
import bg from './imgs/back.gif'
import fg from './imgs/land.jpg'
import mintGif from './imgs/mint.gif'
import dd from './imgs/dd.png'
import React from 'react'
import Web3 from 'web3'

import {
	useAccount,
	useChainId,
  usePrepareTransactionRequest,
  useSendTransaction,
  useWaitForTransactionReceipt,
} from 'wagmi'

import { parseEther } from 'viem'
import { config, shop } from './config'

import pendingGif from './imgs/pending2.gif'
import flashing from './imgs/flashing.gif'
import derpeItems from './imgs/derp-items.png'

import discord from './imgs/discord.png'
import tg from './imgs/icon--telegram.png'
import x from './imgs/icon--twitter.png'

import closeImg from './imgs/close.png'

import drink from './imgs/drink.PNG'
import itemImg from './imgs/cardpack.png'

import dnet from './imgs/dnet.png'
import berpboi from './imgs/berpboi.png'
import derpboi from './imgs/derp0.jpg'
import back from './icons/back.png'
import nextimg from './icons/next.png'
const BERP_IPFS = 'bafybeidnjulenyk3yzlrgd7mdcgb6wpwmq4cdfdk655zsz5bikovyio3py'
const getTransactionReceipt = (hash, callback= ()=>{}) => {
    console.log(hash)
    window.ethereum.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    }).then((res)=>{
      if (res == null) {
        getTransactionReceipt(hash, callback)
      }
      callback(res)
    }).catch((err)=>{
      console.log(err)
    })
  }

const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));



export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()

	const [bal, setBal] = React.useState(0)
  
    const [buttonState, setButtonState] = React.useState("")
    const [pressCount, setPressCount] = React.useState(0)
    const [emitterBalance, setEmitterBalance] = React.useState(0)
    const [isDerpScreen, setIsDerpScreen] = React.useState(true)

	const [networkConfig, setNetworkConfig] = React.useState(config["mainnet"])
	const [isBerpViewerOpen, setIsBerpViewerOpen] = React.useState(false)
	 const [activeBerpId, setActiveBerpId] = React.useState()
    const [balBerps, setBalBerps] = React.useState(0)
    const [activeBerpIndex, setActiveBerpIndex] = React.useState(999)
    const [activeBerpImage, setActiveBerpImage] = React.useState(berpboi)
    const [derpBal, setDerpBal] = React.useState(0)

	const derps = new web3.eth.Contract(networkConfig["derps"]["abi"], networkConfig["derps"]["address"])
	const derper = new web3.eth.Contract(networkConfig["derper"]["abi"], networkConfig["derper"]["address"])
	const derpToken = new web3.eth.Contract(networkConfig["derp"]["abi"], networkConfig["derp"]["address"])
	const berpgod = new web3.eth.Contract(networkConfig["berpgod"]["abi"], networkConfig["berpgod"]["address"]) 
	const berps = new web3.eth.Contract(networkConfig["berps"]["abi"], networkConfig["berps"]["address"])

	React.useEffect(()=>{
		

	},[networkConfig])

  	React.useEffect(
  	() => {
  		if (isConnected && !pending) {
  	
  		} else {
  			if (pending) {
  		
  			} else {
  				if (isConnected) {
  		
  				} else {
  				
  				}
  				
  			}
  		}
  	},
  	[pending, isConnected]
  	)

  	React.useEffect(()=>{
  		if (isBerpViewerOpen) {
  			getBerpBal()
  		}
  	},[isBerpViewerOpen])

  	React.useEffect(()=>{
		if (Number(balBerps) > 0) {
			setActiveBerpIndex(Number(balBerps)-1)
		}
	}, [balBerps])

	 React.useEffect(()=>{
		getBerpIdByIndex()
	},[activeBerpIndex])
	 React.useEffect(()=>{
	 	getBerpMetadata()
	 },[activeBerpId])

	const sendRequest = (contract, data, callback = ()=>{}, payable = 0, gasAmount=0) => {
		setIsPending(true)
	

		if (typeof window.ethereum !== 'object') { 
		
		} else {
		

		window.ethereum.request({
			method: "eth_sendTransaction",
			params: [
			  {
			    from: address,
			    to: contract,
			    value: payable,
			    data: data,
			  },
			],}).then((hash)=>{
			  getTransactionReceipt(hash,(receipt)=>{
			    if (receipt != null) {
			      setIsPending(false)
			      callback()
			    }
			  })
			}).catch((err)=>{
			  setIsPending(false)
			})	
		}
		
	}

	const estimateGas = (contract, data, callback = ()=>{}) => {



	if (typeof window.ethereum !== 'object') {
		alert("Please open this page in the Metamask browser")
	
	} else {

		window.ethereum.request(
	        {
	          method: "eth_estimateGas",
	          params: [
	            {
	              from: address,
	              to: contract,     
	              value: web3.utils.toHex(0),
	              data: data,
	            },
	          ],
	        }
	      ).then((gasAmount)=>{
	      	console.log(gasAmount)
	        callback(gasAmount)
	      }).catch((err)=>{
	        alert(err.data.message)
	      })
	      
		}
   
}
	




  const getBal = () => {
  	derps.methods.balanceOf(address)
  		.call({from: address})
  		.then((balance)=>{
  			setBal(balance)
  		})
  }


const getDerpBal = (callback = ()=>{}) => {
	derpToken.methods.balanceOf(address)
		.call({from: address})
		.then((b)=>{
			callback(b)
		})
}




const isLive = (callback = ()=>{}) => {
	derper.methods.isLive()
		.call({from: address})
		.then((live)=>{
			callback(live)
		})
}

const checkClaim = (callback = ()=>{}) => {
	derper.methods.checkClaim()
		.call({from: address})
		.then((claimAmount)=>{
			callback(Number(web3.utils.fromWei(claimAmount,"ether")))
		})
}

const checkBalanceOfDerper = (callback = ()=>{}) => {
	derpToken.methods.balanceOf(networkConfig["derper"]["address"])
		.call({from: address})
		.then((b)=>{
			callback(b)
			setEmitterBalance(b)
		})
}

const claimDerp = (callback = ()=>{}) => {
	let data = derper.methods.claimDerp().encodeABI()
	setPendingText("claiming your $DERP")
	estimateGas(
		networkConfig["derper"]["address"],
		data,
		()=>{
			sendRequest(
			networkConfig["derper"]["address"],
			data,
			callback
			)
		})
	
}
const changeClaim = () => {
	console.log("go")
	let data = derper.methods.changeAmountPerClaim(2).encodeABI()
	sendRequest(networkConfig["derper"]["address"],data,()=>{})
}

  const press = () => {

    console.log(pressCount)
    setPressCount(pressCount + 1)

    //check isLive
    	// require true
    
	    //checkClaim
	    	// ensure response > 0
	    	//check balanceOf Derper
	    		// ensure balance > claim
	    		// claimDerp
	    		
	isLive((live)=>{
		if (live) {
			checkClaim((claimAmount)=>{
				if (claimAmount > 0) {
					checkBalanceOfDerper((balance)=>{
						console.log(web3.utils.fromWei(balance,"ether"),claimAmount)
						if (Number(web3.utils.fromWei(balance,"ether")) >= Number(claimAmount)) {
							claimDerp(()=>{
								//alert("Success")
							})
						} else {
							alert("Emitter does not have enough $DERP")
						}
					})
				} else {
					alert("Please wait 24 hours before claiming again. If you didn't just claim, this message indicates you do not have an available claim. Please ensure you are using the correct wallet.")
				}
			})
		} else {
			alert("Claim is not live")
		}
	})


  }



 const viewDerpScreen = () => {
 	setIsDerpScreen(true)
 }
 const viewBerpScreen = () => {
 	setIsDerpScreen(false)
 }

 const approveDerp4BerpGod = (callback = ()=>{}) => {
	let data = derpToken.methods.approve(berpgod.options.address,"10000000000000000000000000000000").encodeABI()
	setPendingText("Approving alot of $DERP. Manually reduce to 3200 if you only want to mint once.")
	sendRequest(
		networkConfig["derp"]["address"],
		data,
		callback)

}
const checkAllowance = (contract, spender, callback = ()=>{}) =>{
	contract.methods.allowance(address, spender)
		.call({from: address})
		.then((allowance)=>{
			callback(allowance)
		})
}
const ezBerp = (callback= ()=>{})=>{
	let data = berpgod.methods.ezMint().encodeABI()
	setPendingText("Ez Berping the next available Derp")
	sendRequest(
		berpgod.options.address,
		data,
		callback
		)
}
const pressBerp = () => {
	getDerpBal((balance)=>{
		let b = web3.utils.fromWei(balance,"ether")
		if (b >= 3200) {
			checkAllowance(
				derpToken,
				berpgod.options.address,
				(derpAllowance)=>{
					let d = web3.utils.fromWei(derpAllowance,"ether")
					if (Number(d) >= 3200) {
						ezBerp(()=>{
								getBerpBal(()=>{setIsBerpViewerOpen(true)})
							})
					}
					else {
						approveDerp4BerpGod(()=>{
							ezBerp(()=>{
								getBerpBal(()=>{setIsBerpViewerOpen(true)})
							})
						})
					}
				}
				)
		}
		else {
			alert("You need to purchase more $DERP on Shadow.so");
		}
		
	})
	
}

const nextBerp = () => {
		if (activeBerpIndex < Number(balBerps) - 1 && activeBerpIndex != 999) {
			setActiveBerpIndex(activeBerpIndex + 1)
		}
	}

	const prevBerp = () => {
		if (activeBerpIndex > 0 && activeBerpIndex != 999) {
			setActiveBerpIndex(activeBerpIndex - 1)
		}
	}

	const getBerpIdByIndex = () => {
		if (activeBerpIndex < 999) {
			berps.methods.tokenOfOwnerByIndex(address, activeBerpIndex)
				.call({from: address})
				.then((id)=>{
					setActiveBerpId(id)
				})
			}
		
	}
	const closeBerpViewer = () => {
		setIsBerpViewerOpen(false)
	}

		const getBerpMetadata = () => {
		if (activeBerpId < 10001) {
		
			setActiveBerpImage("https://ipfs.io/ipfs/"+BERP_IPFS+"/" + activeBerpId + ".png")
		}
		
	}
const getBerpBal = (callback=()=>{}) => {
		console.log("Fetching berp balance",address)
		berps.methods.balanceOf(address)
			.call({from: address})
			.then((berpBalance)=>{
				console.log(berpBalance)
				setBalBerps(berpBalance)
				callback(berpBalance)
			})
	}

	


  return (
  	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
	  	<div className="bg">
	       	<div className="action-grid">
	       		<div className="derp-toggle">
	       			<div className="derp-toggle-button">
	       				<div onClick={viewDerpScreen} className={"derp-toggle-button-left derp-toggle-button-left--"+isDerpScreen}>DERP</div>
	       				<div onClick={viewBerpScreen} className={"derp-toggle-button-right derp-toggle-button-right--"+!isDerpScreen}>BERP</div>
	       			</div>
	       		</div>
	       		<div className={"screen screen--berp screen--"+!isDerpScreen}>
		       		<div className="grid-item grid-item--main">
		       			<h2>BERP!</h2>
		       			<div className="grid-item-inner">
		       				<div className="button">
					          {
					            //<h2>{seconds}</h2>
					          }
					          <button className={"btn btn--" + buttonState} onClick={pressBerp}>BERP</button>
					        </div>
					        <p>Berp a Derp for 3200 $DERP.</p>
					        
		       			</div>
		       		</div>
		       		
		       		<div className="grid-item-row">
		       			<div onClick={()=>{setIsBerpViewerOpen(true)}} className="grid-item grid-item--small">
		       				<div className="grid-item-inner">
		       					<img src={berpboi} />
		       					<h3>Berps</h3>
		       				</div>
		       			</div>
		       			<a href="https://shop.derpe.xyz" target="_blank" className="grid-item grid-item--small">
		       				<div className="grid-item-inner">
		       					<img src={itemImg} />
		       					<h3>Items</h3>
		       				</div>
		       			</a>
		       		</div>
		       	</div>

		       	<div className={"screen screen--derp screen--"+isDerpScreen}>
		       		<div className="grid-item grid-item--main">
		       			<h2>WARNING!</h2>
		       			<div className="grid-item-inner">
		       				<div className="button">
					          {
					            //<h2>{seconds}</h2>
					          }
					          <button className={"btn btn--" + buttonState} onClick={press}>DERP</button>
					        </div>
					        <p>Do NOT press the button.</p>
					        
		       			</div>
		       		</div>
		       		
		       		<div className="grid-item-row">
		       			<a href="https://my.derpe.xyz" target="_blank" className="grid-item grid-item--small">
		       				<div className="grid-item-inner">
		       					<img src={derpboi} />
		       					<h3>Derps</h3>
		       				</div>
		       			</a>
		       			<a href="https://shop.derpe.xyz" target="_blank" className="grid-item grid-item--small">
		       				<div className="grid-item-inner">
		       					<img src={itemImg} />
		       					<h3>Items</h3>
		       				</div>
		       			</a>
		       		</div>
		       	</div>


	       	</div>
	       	 <div className="links">
	      
	           
	          <a href="https://discord.gg/3BUen4F9Tw" target="_blank"><img src={discord} /></a>
	          
	          <a href="https://t.me/derpedewdz" target="_blank"><img src={tg}/></a>
	          
	          <a href="https://x.com/derpedewdz" target="_blank"><img src={x}/></a>
	          
	        </div>
 			<div className={"berps berps--"+isBerpViewerOpen}>
		 		
	  			<p>You have {balBerps} Berps</p>

	  			<div className="mint-box">
		  			<div className="berp">
		  				<img src={activeBerpImage} />
		  			</div>
		  	
		  			<div className="change-nft">
		  				<div className="change back" onClick={prevBerp}><img src={back} /></div>
		  				<span>{activeBerpId}</span>
		  				<div className="change next" onClick={nextBerp}><img src={nextimg} /></div>
		  			</div>	
		  	
  				</div>
  				<div><button onClick={closeBerpViewer}>Back</button><a className="no-shadow" href="https://derpnet.derpe.xyz/berpdash" target="_blank"><button>Berp Dash</button></a></div>
  			</div>
	        
	        
	        <div className="dd"><img src={dd}/></div>
	  		

	  		

	        <div className="connect-button">
	  			<div className="inliner docs"><a href="https://docs.derpe.xyz" target="_blank">DOCS</a></div>
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>

	        <div className={"pending pending--" + pending}>
	  			<p className="pending-title">Transaction Pending</p>
	  			<p className="pending-text">{pendingText}</p>
	  			<div className="pending-gif"><img src={pendingGif} /></div>
	  		</div>
         
      </div>

	  	
	 
  	</div>
  	)
};